import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

import "./style.css";

const DatePick = ({
  className,
  placeholder,
  onChange,
  onPanelChange,
  disabledDate,
  defaultValue,
  superPrevIcon = false,
  superNextIcon = false,
  prevIcon = <span>prev</span>,
  nextIcon = <span>next</span>,
  dropdownClassName,
}) => {
  // console.log(prevIcon, nextIcon);
  const customFormat = (value) =>
    moment().format("ll") === value.format("dddd Do")
      ? "TODAY"
      : value.format("dddd Do");
  return (
    <DatePicker
      className={className}
      placeholder={placeholder}
      onChange={(e) => onChange(e)}
      onPanelChange={onPanelChange}
      disabledDate={disabledDate}
      defaultValue={defaultValue}
      format={customFormat}
      superPrevIcon={superPrevIcon}
      superNextIcon={superNextIcon}
      prevIcon={prevIcon}
      nextIcon={nextIcon}
      dropdownClassName={dropdownClassName}
    />
  );
};

export default DatePick;
